module.exports = __webpack_public_path__ + "img/slider-2.431c6f0e.jpg";